import Vue from "vue"
import VueRouter, {RouteConfig} from "vue-router"
import Home from "../views/Home.vue"
import Versions from "../views/Versions.vue"
import EnvironmentStatus from "@/components/EnvironmentStatus.vue"
import SSOAuthLanding from "@/views/SSOAuthLanding.vue"
import Logout from "@/views/Logout.vue"
import Licences from "@/views/Licences.vue"
import MultiTenantEnvironments from "@/views/MultiTenantEnvironments.vue"
import EnvironmentFirewalls from "@/components/EnvironmentFirewalls.vue"

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "DevOps Console - Home",
    },
  },
  {
    path: "/versions",
    name: "Versions",
    component: Versions,
    meta: {
      title: "DevOps Console - Versions",
    },
  },
  {
    path: "/licences",
    name: "Licences",
    component: Licences,
    meta: {
      title: "DevOps Console - Licences",
    },
  },
  {
    path: "/mtenvironments",
    name: "MTEnvs",
    component: MultiTenantEnvironments,
    meta: {
      title: "DevOps Console - Multi-tenant environment status",
    },
  },
  {
    path: "/environment/:id?",
    name: "environment",
    component: EnvironmentStatus,
    props: true,
    meta: {
      title: "DevOps Console - Env status",
    },
  },
  {
    path: "/environment/:environment/firewalls",
    name: "firewalls",
    component: EnvironmentFirewalls,
    props: true,
    meta: {
      title: "Firewalls - DevOps Console",
    },
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/About.vue"),
    meta: {
      title: "DevOps Console - About",
    },
  },
  {
    path: "/auth",
    name: "auth",
    component: SSOAuthLanding,
    meta: {
      title: "SSO Auth",
    },
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout,
    meta: {
      title: "SSO Auth",
    },
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

export default router

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title
  next()
})
